import {create} from 'zustand';
import {FiltersSetDto} from '../../../global/api';

interface ContractTableFiltersEditModalState {
  editableFilter: FiltersSetDto | null;

  contractTableFiltersEditModalOpen: (editableFilter: FiltersSetDto) => void;
  contractTableFiltersEditModalClose: () => void;
}

export const useContractTableFiltersEditModalStore = create<ContractTableFiltersEditModalState>((set, get) => ({
  editableFilter: null,

  contractTableFiltersEditModalOpen: (editableFilter) => set({editableFilter}),
  contractTableFiltersEditModalClose: () => set({editableFilter: null}),
}));

export const {contractTableFiltersEditModalOpen, contractTableFiltersEditModalClose} =
  useContractTableFiltersEditModalStore.getState();
